// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"046f65e2","40":"819eca02","404":"21ca1e4c","498":"7477927e","513":"e444e8c8","787":"78cab7fe"}[chunkId] + ".chunk.js";
};